<div class="d-lg-block d-none">
  <fgb-banner [title]="'faq.text' | translate"></fgb-banner>
</div>
<div class="widget-mobile">
  <div class="container">
    <fgbcl-faq-section></fgbcl-faq-section>
  </div>
</div>
